import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-add-load",
  templateUrl: "./admin-add-load.component.html",
  styleUrls: ["./admin-add-load.component.css"],
})
export class AdminAddLoadComponent implements OnInit {
  loadForm!: FormGroup;
  token: any;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  material: any[] = [];
  LoadId: any;
  loadTypeValidation: boolean = false;
  Commercial: any;
  NonCommercial: any;
  hsnCodeList: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    private matdialogref: MatDialogRef<AdminAddLoadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.details?.loadCategory === "Commercial") {
      this.Commercial = data?.details?.loadCategory;
    } else {
      this.NonCommercial = data?.details?.loadCategory;
    }
  }

  // ngOnInit(): void {
  //   this.token = localStorage.getItem("adminToken");
  //   this.loadForm = this.formBuilder.group({
  //     loadCategory: ["", [Validators.required]],
      
  //     loadId: [this.data?.details?.loadId || null],
  //   });
  //   console.log(this.data?.details?.loadId)
  //   if (this.data.details !== null) {
  //     this.loadForm.patchValue(this.data.details);
  //     this.material = this.data.details.loadType
  //       ? this.data.details.loadType
  //       : [];
  //   }
  // }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.loadForm = this.formBuilder.group({
      loadCategory: ["", [Validators.required]],
      loadId: [""],
    });
    this.getHSNCodes();
    if (this.data.details !== null) {
      this.loadForm.patchValue(this.data.details);
      this.material = this.data.details.loadType
        ? this.data.details.loadType
        : [];
    }
  }

  public close() {
    this.matdialogref.close({ event: "Cancel" });
  }

  // public add(event: MatChipInputEvent): void {
  //   const value = (event.value || "").trim();
  //   let isDuplicate = this.material?.find((ele: any) => {
  //     return ele.toLowerCase() === value.toLowerCase() ? true : false;
  //   });
  //   if (value && !isDuplicate) {
  //     this.material.push(value);
  //   } else if (isDuplicate) {
  //     this.snackBar.open("Load Type Exists", "Fail", {
  //       duration: 5000,
  //     });
  //   }
  //   event.chipInput!.clear();
  // }

  // remove(item: any): void {
  //   const index = this.material.indexOf(item);
  //   if (index >= 0) {
  //     this.material.splice(index, 1);
  //   }
  // }

  public add(event: MatChipInputEvent): void {
  const value = (event.value || "").trim();

  // Split the input by comma or space to separate name and HSN if typed together
  // e.g. "Bricks, 12345"
  const [name, hsn] = value.split(",").map((v) => v.trim());

  if (!name || !hsn) {
    this.snackBar.open("Please enter both Material Name and HSN Code (e.g. Bricks, 12345)", "Fail", {
      duration: 4000,
    });
    event.chipInput!.clear();
    return;
  }

  // Check for duplicate by name
  const isDuplicate = this.material.some(
    (ele: any) => ele.name.toLowerCase() === name.toLowerCase()
  );

  if (!isDuplicate) {
    this.material.push({ name, hsn_code: hsn });
  } else {
    this.snackBar.open("Material already exists", "Fail", {
      duration: 4000,
    });
  }

  event.chipInput!.clear();
}

public remove(item: any): void {
  const index = this.material.indexOf(item);
  if (index >= 0) {
    this.material.splice(index, 1);
  }
}

  public AddLoadDetails() {
    if (!this.loadForm.valid) {
      this.loadForm.markAllAsTouched();
      return;
    }
    // Validate if material list is not empty
    if (!this.material || this.material.length <= 0) {
      this.loadTypeValidation = true;
      this.snackBar.open("Material list should not be empty", "Fail", {
        duration: 5000,
      });
      return;
    }
    // Validate that each material has both name and hsn_code
    const invalidMaterial = this.material.some(
      (item: any) => !item.name || !item.hsn_code
    );
    if (invalidMaterial) {
      this.snackBar.open("Each material must include both Name and HSN Code", "Fail", {
        duration: 5000,
      });
      return;
    }
    const loadDetails = {
      load_category: this.loadForm.value.loadCategory,
      material_type: this.material.map((item: any) => ({
        name: item.name,
        hsn_code: item.hsn_code,
      })),
    };
    this.services.AddLoadDetails(loadDetails, this.token).subscribe(
      (response: any) => {
        if (response.status === 201) {
          console.log("loadDetailsloadDetailsloadDetails",loadDetails)
          this.matdialogref.close({ event: "Success" });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed" || error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  newMaterial = { name: '', hsn_code: '' };

  addMaterial() {
    if (this.newMaterial.name && this.newMaterial.hsn_code) {
      this.material.push({ ...this.newMaterial });
      this.newMaterial = { name: '', hsn_code: '' };
    }
  }

  getHSNCodes(): void {
    const userType = 'customerGST';
    const userName = -1;
    const perPage = '';
    const page = 1;

    this.services.TaxGet(this.token, userType, userName, perPage, page).subscribe({
      next: (response: any) => {
        // Check where your data actually exists
        const data =
          response?.body?.data?.data ||
          response?.body?.data ||
          [];

        if (data.length) {
          this.hsnCodeList = data;
          console.log('this.hsnCodeList', this.hsnCodeList);
        } else {
          console.warn('No HSN codes found.');
        }
      },
      error: (error) => {
        console.error('Error fetching HSN codes:', error);
      }
    });
  }

  public EditLoadDetails() {
    if (!this.loadForm.valid) {
      this.loadForm.markAllAsTouched();
      return;
    } 
    if (this.material.length <= 0) {
      this.loadTypeValidation = true;
      this.snackBar.open("Load Type Should not be Empty or Required", "Fail", {
        duration: 5000,
      });
      return;
    }
    const loadDetails = {
      load_category: this.loadForm.value.loadCategory,
      material_type: this.material.map((item: any) => ({
        name: item.name,
        hsn_code: item.hsn_code
      })),
    };
    this.services
      .EditLoadDetails(loadDetails, this.token, this.loadForm.value.loadId)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.close();
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed" || error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          } else if (error.status === 406) {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
            this.close();
          } else {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        }
      );
  }
}
